import { Item } from "./item";

export class SummaryItem {
    item: Item;

    amount: number;

    constructor(item: Item, amount: number = 1) {
        this.item = item;
        this.amount = amount;
    }

    public get summaryText(): string {
        return this.item.displayText || this.item.retailerId || this.item.id;
    }
}
